import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/idlbay.png";

const LandingFooter = () => {
  return (
    <Fragment>
      <footer
        className="footer mt-auto py-3"
        style={{
          fontFamily: "Fira Code, monospace",
          background: "#fff",
          borderTop: "1px solid #e9ecef",
          fontSize: "0.875rem",
          width: "100%",
          flexShrink: 0,
        }}
      >
        <div className="container-fluid">
          <div className="row align-items-center justify-content-between text-center text-md-start">
            
            {/* ===== Left: Copyright ===== */}
            <div className="col-12 col-md-4 mb-2 mb-md-0">
              <span
                className="text-muted"
                style={{
                  fontSize: "0.8rem",
                  fontWeight: "400",
                }}
              >
                &copy; 2025 Payroll Product. All Rights Reserved.
              </span>
            </div>

            {/* ===== Middle: Legal Links ===== */}
            <div className="col-12 col-md-4 mb-2 mb-md-0">
              <div className="d-flex justify-content-center gap-3">
                <Link
                  to="/Terms"
                  className="text-muted"
                  style={{
                    textDecoration: "none",
                    fontSize: "0.8rem",
                    transition: "color 0.2s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.color = "#FF4B2B")}
                  onMouseLeave={(e) => (e.target.style.color = "#6c757d")}
                >
                  Terms & Conditions
                </Link>
                <span className="text-muted">|</span>
                <Link
                  to="/PrivacyPolicy"
                  className="text-muted"
                  style={{
                    textDecoration: "none",
                    fontSize: "0.8rem",
                    transition: "color 0.2s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.color = "#FF4B2B")}
                  onMouseLeave={(e) => (e.target.style.color = "#6c757d")}
                >
                  Privacy Policy
                </Link>
              </div>
            </div>

            {/* ===== Right: Powered By ===== */}
            <div className="col-12 col-md-4">
              <div className="d-flex justify-content-center justify-content-md-end align-items-center">
                <span
                  className="text-muted me-2"
                  style={{
                    fontSize: "0.8rem",
                    fontWeight: "400",
                  }}
                >
                  Powered By
                </span>
                <Link
                  to="https://idlbay.com"
                  className="fw-semibold"
                  style={{
                    textDecoration: "none",
                    transition: "opacity 0.2s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.opacity = "0.7")}
                  onMouseLeave={(e) => (e.target.style.opacity = "1")}
                >
                  <img
                    src={logo}
                    alt="IDLBAy"
                    style={{
                      height: "24px",
                      verticalAlign: "middle",
                      transition: "transform 0.2s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                    onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <style>{`
          @media (max-width: 768px) {
            .footer {
              padding-top: 0.75rem !important;
              padding-bottom: 0.75rem !important;
            }
            .footer .container-fluid {
              padding-left: 1rem;
              padding-right: 1rem;
            }
          }

          @media (max-width: 576px) {
            .footer {
              font-size: 0.75rem !important;
            }
            .footer img {
              height: 20px !important;
            }
            .footer .row {
              flex-direction: column;
              gap: 0.6rem;
            }
            .footer .col-12 {
              text-align: center !important;
            }
          }

          @media (max-width: 360px) {
            .footer {
              padding-top: 0.5rem !important;
              padding-bottom: 0.5rem !important;
            }
          }
        `}</style>
      </footer>
    </Fragment>
  );
};

export default LandingFooter;
